import React, {useContext} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper/modules';

import 'swiper/css';

import {ClientWidthContext} from '../Context/ApplicationContextProvider';
import BrandNoveltyCard from './BrandNoveltyCard';

function BrandNovelties({items, title, buttonTitle}) {
  const clientWidth = useContext(ClientWidthContext);
  const isMobile = clientWidth < 1280;

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <section className="mt-[50px] phone:mt-[30px]">
      {title && (
        <h2 className="mb-[16px] mt-0 text-[24px] !font-['OtoiwoGroteskExtended'] font-semibold leading-normal text-[#000] phone:text-[20px] 500:!text-[18px]">
          {title}
        </h2>
      )}
      {isMobile ? (
        <div className="relative">
          <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={20}
            breakpoints={{
              768: {
                slidesPerView: 2,
                spaceBetween: 37,
              },
            }}
            pagination={items.length > 1 ? {
              type: 'progressbar',
              el: '#brand-novelties-pagination',
              progressbarFillClass: 'absolute left-0 top-0 h-full w-full origin-top-left bg-blue-primary',
            } : false}
            className="w-full [&_.swiper-wrapper]:!h-auto [&_.swiper-wrapper]:items-stretch"
          >
            {items.map(item => (
              <SwiperSlide key={`brand-novelty-slide-${item.id}`} className="!h-auto">
                <BrandNoveltyCard item={item} buttonTitle={buttonTitle}/>
              </SwiperSlide>
            ))}
          </Swiper>

          {items.length > 1 && (
            <div
              id="brand-novelties-pagination"
              className="absolute bottom-[-11px] left-0 top-auto z-10 h-1 w-full bg-grey-10"
              style={{top: 'auto', bottom: '-11px'}}
            />
          )}
        </div>
      ) : (
        <div className="grid auto-rows-fr grid-cols-3 gap-[37px]">
          {items.map(item => (
            <BrandNoveltyCard
              key={`brand-novelty-${item.id}`}
              item={item}
              buttonTitle={buttonTitle}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default BrandNovelties;